import React from 'react';
import TuningPhilosophyContent from './TuningPhilosophyContent';
import { philosophyIntro, philosophyFaqCategories } from '../data/philosophyFaq';
import './TuningGuidePage.css';

function TuningGuidePage() {
  return (
    <div className="tuning-guide-page home-container content-full-flow">
      <header className="tuning-guide-page-header">
        <h1>Tuning guide</h1>
        <p className="tuning-guide-page-lede">
          Complete in-app reference—starts with a <strong>terms and definitions</strong> block (compression vs rebound, p90/p95, stroke
          count vs depth, etc.), then position, velocities, depth, counts, symptoms, and portal tips. Same FAQ format as the public
          tuning philosophy, with full depth and numeric references.
        </p>
      </header>
      <TuningPhilosophyContent variant="guide" intro={philosophyIntro} categories={philosophyFaqCategories} />
    </div>
  );
}

export default TuningGuidePage;
